import React from 'react';
import { Snackbar, Box, Paper, Typography } from '@mui/material';
import { LinearProgressWithLabel } from './LinearProgressWithLabel';

interface SnackbarProgressProps {
    open: boolean;
    percentage: number;
    label?: string;
}

export const SnackbarProgress: React.FC<SnackbarProgressProps> = ({ open, percentage, label = 'Subiendo archivo' }) => {
    return (
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={open}
            key={'bottomcenter'}
            sx={{ width: '100%', maxWidth: 500 }}
        >
            <Paper sx={{ width: '100%', p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body2" color="textSecondary" fontWeight="bold">
                    Procesando y Subiendo...
                </Typography>
                <Box sx={{ width: '100%' }}>
                    <LinearProgressWithLabel percentage={percentage} label={label} hasIcon={true} />
                </Box>
            </Paper>
        </Snackbar>
    );
};
